export default __webpack_public_path__ + "static/media/ilustrasi-2.a6bc8335.svg";